import { render } from "./TrainEvaluateView.vue?vue&type=template&id=ea58b56a&scoped=true"
import script from "./TrainEvaluateView.vue?vue&type=script&lang=js"
export * from "./TrainEvaluateView.vue?vue&type=script&lang=js"

import "./TrainEvaluateView.vue?vue&type=style&index=0&id=ea58b56a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea58b56a"]])

export default __exports__